import { render, staticRenderFns } from "./Attention.vue?vue&type=template&id=c854a1f6&"
import script from "./Attention.vue?vue&type=script&lang=ts&"
export * from "./Attention.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports